import { OperationType, Ticket } from "./Entity";

export class Contracted extends Ticket {
  constructor() {
    super();
  }

  // Dados da operação
  id: number = null;
  operationDate: Date = null;
  settlementDate: Date = null;
  operationTypeId: OperationType = null;
  amount: number = null;
  unitPriceOutward: number = null;
  unitPriceReturn: number = null;
  returnDate: Date = null;
  valueOutward: number = null;
  valueReturn: number = null;
  operationValue: number = null;
  command: string = null;
  annotations: string = null;

  // Dados do título
  security = "";
  securityId = "";
  expirationDate: Date = null;
  issueTax: number = null;

  // Dados da Contraparte
  counterpartName = "";
  counterpartDocument = "";
  counterpartSelicAccount = "";

  // Dados Carteira/Fundo
  portfolioName = "";
  portfolioCode = "";
  portfolioDocument = "";
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount = "";
  portfolioSelicAccount = "";
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;
}
